import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "file-uploader" }
const _hoisted_2 = {
  key: 0,
  class: "upload-btn-title"
}
const _hoisted_3 = {
  key: 0,
  class: "file-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      accept: "image/*",
      class: "file-input",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
    }, null, 544),
    _createElementVNode("button", {
      type: "button",
      class: "upload-btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerInput && _ctx.triggerInput(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        size: "lg",
        icon: ['fas', 'file-upload']
      }),
      (_ctx.isTitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.t('upload')), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.fileName && _ctx.isShowSign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.fileName), 1))
      : _createCommentVNode("", true)
  ]))
}